import { render, staticRenderFns } from "./RightsholdersChallengeList.vue?vue&type=template&id=16e25248&scoped=true&"
import script from "./RightsholdersChallengeList.vue?vue&type=script&lang=js&"
export * from "./RightsholdersChallengeList.vue?vue&type=script&lang=js&"
import style0 from "./RightsholdersChallengeList.vue?vue&type=style&index=0&id=16e25248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e25248",
  null
  
)

export default component.exports